import { get } from "lodash";
import PropTypes from "prop-types";
import queryString from "query-string";
import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Container,
  Row,
  Image,
  Dropdown,
  Form,
  Modal
} from "react-bootstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  clearDownloadAgendaMeetingExcelAction,
  clearDownloadAgendaMeetingPptAction,
  clearDownloadAgendaMeetingCabSecPptAction,
  clearDownloadAgendaMeetingPptv2Action,
  downloadAgendaMeetingExcel,
  downloadAgendaMeetingPpt,
  downloadAgendaMeetingPptv2,
  downloadAgendaCabSecPpt,
  clearDownloadAgendaMeetingPptv2WithoutIssueAction,
  downloadAgendaMeetingPptv2PragatiFormat,
  clearDownloadAgendaMeetingPptv2PragatiFormatAction,
  clearDownloadUpdaloadAgendaTemplateAction,
  downloadUpdaloadAgendaTemplateAction
} from "../../actions/dowloadExcelActions";
import {
  agendaHistory,
  downloadMinuteAction,
  getAgendaStakeHolderAction,
  getAgendaSummary,
  getMomDetails,
  sendMeetingRequest,
  sendMinuteAction,
  setUpdateMeetingFilesAction,
  updateMom
} from "../../actions/mom.action";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DownloadAgenda } from "../../component/DownloadAgenda";
import DownloadAgendaBrief from "../../component/DownloadAgendaBrief";
import DownloadAgendaByType from "../../component/DownloadAgenda/DownloadAgendaByType.js";
import DownloadAgendaParticipants from "../../component/DownloadAgendaParticipants";
import { LoaderPage } from "../../component/Loader";
import TooltipComponent from "../../component/TooltipComponent";
import {
  DOCUMENT_FORMATS,
  //DOCUMENT_FORMATS_AGENDA,
  DOCUMENT_FORMATS_FOR_CONCLUDED_AGENDA,
  ERROR_MSG,
  MEETING_OPTION,
  PATHS,
  STATUS,
  DROP_DOWN_VALUES
} from "../../constant";
import {
  dateFormat,
  dateFormatWithTime,
  getLocalstorage,
  isValidArray,
  getAgendaTagsColor,
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate
} from "../../helper";
import request from "../../services/requestService";
import { _downloadUploadAgendaTemplate } from "../../services/apiServices";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { AgendaCardInfo } from "../createAgenda/agendaCardInfo";
import PermissionHOC from "../PermissionHOC";
import {
  DisplayAttachments,
  DownloadExcelReport,
  ModalComponent,
  ModalTemplate,
  UploadAttachmentsWithTitleComponent
} from "../reusableComponent";
import { SendByComponent1 } from "../sendNotification/Agendaindex";
import { DownloadUploadComponent } from "./downloadUploadReport";
import EditAgenda from "./editAgenda/editAgendaModal";
import GuestList from "./Guests";
import IssueSingleList from "./IssueSingleList";
import { successToastStyle, errorToastStyle } from "../../customToast";
import Meeting from "../../assets/meeting.svg";
import ChairedBy from "../../assets/created-by.svg";
import AgendaSentIcon from "../../assets/agenda-sent-form.svg";
import MeetingModeIcon from "../../assets/meeting-mode-icon.svg";
import Calendar from "../../assets/add-decision-calendar.svg";
import Venue from "../../assets/venue.svg";
import { getMeetingTypesDetails } from "../../actions/projectDetail.action";
import DisabledPPt from "../../assets/disabled-ppt.svg";
import { AgendaDropdown } from "../reusableComponent/customSelectDropDown/AgendaDropdown";
import { DownloadExcelReport1 } from "../reusableComponent/downloadMisComponent/index1";
import { DownloadExcelReport as DownloadExcelReportNew } from "../reusableComponent/downloadMisComponent";
import ProjectIssueSingle from "../createAgenda/ProjectIssueSingle";
import { guestListAction } from "../../actions/issuesListAction.actions";
import { SelectProject } from "../createAgenda/selectProject/SelectProject";
import { DownloadExcelReportAgenda } from "../reusableComponent/downloadMisComponent/agendaIndex.js";
import saveChangesOrange from "../../assets/save_changes_orange_icon.svg";
import saveChangesWhite from "../../assets/save_changes_icon.svg";
import { getUpcommingAgendaFlagAction } from "../../actions/pragati.action.js";
import { UploadProjectsIssuesComponent } from "../reusableComponent/uploadProjectsIssues/UploadProjectsIssues.js";
import UploadedListModal from "../createAgenda/uploadProjectIssues/UploadedListModal.js";
import { UploadErrorModal } from "../createAgenda/uploadProjectIssues/UploadErrorModal.js";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NoDataFoundIcon =
  "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png";

class AgendaDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      loadingStatus: false,
      isConfirmModalVisible: false,
      agendaMeetingTypeDetails: [],
      isPPTChecked: false,
      selectedValue: "",
      selectedProjectIssues: [],
      isAddIssueModalVisible: false,
      isAddProjectModalVisible: false,
      underMaintenance: false,
      changedRecipientToggle: false,
      dataRecipient: "",
      toggleUploadDisplay: false,
      showUploadedResultModal: false,
      showUploadErrorModal: false,
      displayExcelIcon: true,
      displayLoader: false,
      downloadExcelTemplate: ""
    };
  }

  componentDidMount() {
    const { location, history, getMeetingTypesDetails } = this.props;
    const { agendaId: _agendaId } = queryString.parse(location.search);
    if (location.state) {
      const { agendaId } = location.state;
      this.getInitialCalls(agendaId);
    } else if (_agendaId) {
      this.getInitialCalls(_agendaId);
    } else {
      history.push(PATHS.AGENDA_LIST);
    }
    getMeetingTypesDetails().then(resp => {
      if (resp) {
        this.setState({ agendaMeetingTypeDetails: resp });
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { uploadedList } = this.props;
    if (prevProps.uploadedList !== uploadedList) {
      console.log("New Uploaded List:", uploadedList);
      if (uploadedList.errorStatus) {
        const hasValidProjects =
          uploadedList &&
          Array.isArray(uploadedList.projectsData) &&
          uploadedList.projectsData.length > 0;

        if (hasValidProjects) {
          this.setState({ showUploadedResultModal: true });
        } else {
          this.setState({ showUploadErrorModal: true });
        }
      }
    }

    if (prevProps.agendaDetails !== this.props.agendaDetails) {
      if (this.props.agendaDetails !== null) {
        let agendaData = this.props.agendaDetails.data;
        //   agendaData.fileDTOList = [
        //     {
        //         "id": 14124,
        //         "title": "ghfjufmyj",
        //         "mineType": "image/png",
        //         "name": "Pending with RMRS.png",
        //         "s3Url": "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1719224342302-Pending_with_RMRS.png",
        //         "s3FileName": null
        //     }
        // ]

        this.setState({ localValue: this.props.agendaDetails.data });
        const selectedProjects = get(agendaData, "projectsData", []);
        //get selected issues
        let selectedIssues = [];
        const { groupCategory } = getLocalstorage("user");
        get(agendaData, "issuesData", []).forEach(issue => {
          //console.log("agendaIssue", issue)
          // if (
          //   (groupCategory === "PMG" &&
          //     (issue.status === "Pending with RM/RS" ||
          //       issue.status === "Under PMG Decision" ||
          //       issue.status === "Pending with SM" ||
          //       issue.status === "Pending with PMG")) ||
          //   (groupCategory === "STATE_PMG" &&
          //     (issue.status === "Under State PMG Decision" ||
          //       issue.status === "Pending with RD" ||
          //       issue.status === "Pending with RM/RS")) ||
          //   groupCategory === "STATE" ||
          //   groupCategory === "CENTRAL_DEPARTMENT" ||
          //   groupCategory === "CENTRAL"
          // ) {
          selectedIssues.push({
            id: issue.id,
            creatorName: issue.creatorName,
            title: issue.title,
            description: issue.description,
            createdDate: issue.createdDate,
            status: issue.status,
            recipientGroup: issue.recipientState,
            assigneeGroup: issue.assigneeGroup,
            assignedForDays: issue.modifiedDate,
            category: issue.category,
            subCategory: issue.subCategory,
            meetingDecisionDTOS: issue.meetingDecisionDTOS,
            recipientGroupCategory: issue.recipientGroupCategory,
            recipientGroupId: issue.recipientGroupId,
            districtName: issue.districtName,
            districtDeptId: issue.districtDeptId,
            duplicate: issue.duplicate,
            displayActions: issue.displayActions,
            escalationLevelName: issue.escalationLevelName,
            secondaryMinistry: issue.secondaryMinistry,
            secondaryMinistryId: issue.secondaryMinistryId,
            secondaryMinistryDepartment: issue.secondaryMinistryDepartment,
            secondaryMinistryDepartmentId: issue.secondaryMinistryDepartmentId,
            secondaryState: issue.secondaryState,
            secondaryStateId: issue.secondaryStateId,
            secondaryStateDepartment: issue.secondaryStateDepartment,
            secondaryStateDepartmentId: issue.secondaryStateDepartmentId,
            secondaryRecipientGroupId: issue.secondaryRecipientGroupId,
            secondaryRecipientGroupName: issue.secondaryRecipientGroupName,
            project: {
              id: issue.projectId,
              totalCost: issue.totalCost,
              name: issue.projectName,
              sponsoredById: issue.sponsoredById,
              sponsoredBy: issue.sponsoringMinistry,
              displayId: issue.displayId,
              sponsoringMinistry: issue.sponsoringMinistryCategory,
              sponsoringDepartment: issue.sponsoringDepartment,
              pli: issue.pli,
              pragatiReview: issue.pragatiReview,
              nipReview: issue.nipReview,
              pmGatiShakti: issue.pmGatiShakti,
              pmFoundationStone: issue.pmFoundationStone,
              march24: issue.march24,
              organizationName: issue.organizationName,
              projectStatusWithRespectToIssueStatus:
                issue.projectStatusWithRespectToIssueStatus,
              projectCompletionDTO: issue.projectCompletionDTO,
              projectSector: issue.projectSector,
              projectCategory: issue.projectCategory,
              projectPPList: issue.projectPPList
            },
            isSelected: true,
            issuePragatiReview: issue.issuePragatiReview,
            issuePragatiPipeLine: issue.issuePragatiPipeLine,
            latestIssueComments: issue.latestIssueComments,
            projectCreatedBy: issue.projectCreatedBy,
            verificationDate: issue.verificationDate,
            recipientLabel: issue.recipientLabel
          });
          // }
        });
        //console.log("selectedIssues", selectedIssues);
        //calculate selectedprojectIssues array
        let selectedProjectIssues = [];
        selectedProjectIssues = selectedProjects.map(selectedProject => {
          const updatedProject = { ...selectedProject };
          updatedProject.issuesSelected = selectedIssues.filter(
            selectedIssue => selectedProject.id === selectedIssue.project.id
          );
          return updatedProject;
        });
        this.setState({
          selectedIssues: selectedIssues,
          selectedProjectIssues: selectedProjectIssues
        });
      }
    }
  }

  getInitialCalls = agendaId => {
    const {
      getMomDetails,
      clearDownloadAgendaMeetingPptv2Action,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      clearDownloadAgendaMeetingExcelAction
    } = this.props;
    getMomDetails(undefined, { momId: agendaId });
    this.handleHistory(agendaId);
    clearDownloadAgendaMeetingPptv2Action();
    clearDownloadAgendaMeetingPptAction();
    clearDownloadAgendaMeetingCabSecPptAction();
    clearDownloadAgendaMeetingExcelAction();
  };

  changeAgendaDetail = agendaId => {
    const {
      getMomDetails,
      history,
      clearDownloadAgendaMeetingPptv2Action,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      clearDownloadAgendaMeetingExcelAction
    } = this.props;
    if (agendaId) {
      getMomDetails(undefined, { momId: agendaId });
      this.handleHistory(agendaId);
      clearDownloadAgendaMeetingPptv2Action();
      clearDownloadAgendaMeetingPptAction();
      clearDownloadAgendaMeetingCabSecPptAction();
      clearDownloadAgendaMeetingExcelAction();
    } else history.push(PATHS.AGENDA_LIST);
  };

  handleDropdownSelect = value => {
    this.setState({ selectedValue: value });
    if (this.state.selectedValue.title === "With Issue Status") {
      const { isPPTChecked } = this.state;
      this.setState({
        isPPTChecked: !isPPTChecked
      });
    }
  };

  handleDownloadLinkClick = () => {
    this.setState({ selectedValue: "" });
  };

  handleAgendaHistory = id => {
    const { getMomDetails, history } = this.props;
    history.push({
      pathname: PATHS.AGENDA_DETAILS,
      search: `?agendaId=${id}`,
      state: {
        agendaId: id
      }
    });
    getMomDetails(undefined, { momId: id });
  };

  handleUpdateStatus = () => {
    const { getMomDetails, location } = this.props;
    const { agendaId: _agendaId } = queryString.parse(location.search);
    if (location.state) {
      const { agendaId } = location.state;
      getMomDetails(undefined, { momId: agendaId });
      this.handleHistory(agendaId);
    } else if (_agendaId) {
      getMomDetails(undefined, { momId: _agendaId });
      this.handleHistory(_agendaId);
    }
  };

  setRecipientChange = data => {
    if (data.data.notifications.length != 0) {
      this.setState({ changedRecipientToggle: true });
      this.setState({ dataRecipient: data.data.notifications });
    }
  };

  handleRecipientClose = () => {
    this.setState({
      changedRecipientToggle: !this.state.changedRecipientToggle
    });
  };

  handleHistory = async id => {
    const response = await agendaHistory(undefined, { id: id });
    if (response && response.status) {
      this.setState({
        history: response.data
      });
    }
  };

  handlePrint = () => {
    window.print();
  };

  saveChanges = async () => {
    const { agendaDetails, history, updateMom, getMomDetails } = this.props;
    this.setState({
      loadingStatus: true
    });
    let agendaData = null;
    if (agendaDetails && agendaDetails.data) {
      agendaData = agendaDetails.data;
      //need to remove in pragati phase-2 start
      agendaData = {
        ...agendaData,
        users: agendaData.users.map(user => {
          if (user.guestCategory === "NA") {
            return { ...user, guestCategory: null };
          }
          return user;
        })
      };
      //need to remove in pragati phase-2 end
      agendaData.issues = (this.state.selectedIssues || []).map(
        issue => issue.id
      );
      agendaData.projects = (this.state.selectedProjectIssues || []).map(
        project => project.id
      );
      //fileAttachment start
      if (
        agendaData &&
        agendaData.fileDTOList &&
        agendaData.fileDTOList.length
      ) {
        const files = agendaData.fileDTOList.map(value => value.id);
        agendaData.fileAttachment = files && files[0];
      }
      //fileAttachment stop
      //agendaData.meetingStatus = meetingStatus;
      let response = null;
      response = await updateMom(undefined, agendaData);

      if (response) {
        this.setState({
          loadingStatus: false
        });
        const { message, status } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">
              Meeting updated successfully!
            </p>,
            successToastStyle
          );
          getMomDetails(undefined, { momId: get(response, "data", null) });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        this.setState({
          loadingStatus: false
        });
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    }
  };

  changeMeetingStatus = async meetingStatus => {
    const {
      agendaDetails,
      history,
      updateMom,
      getMomDetails,
      getUpcommingAgendaFlagDispatch
    } = this.props;
    this.setState({
      loadingStatus: true
    });
    let agendaData = null;
    if (agendaDetails && agendaDetails.data) {
      agendaData = agendaDetails.data;
      agendaData.meetingStatus = meetingStatus;
      let response = null;
      if (meetingStatus === "RESCHEDULE") {
        response = await updateMom(undefined, agendaData);
      } else {
        response = await updateMom(undefined, {
          id: agendaData && agendaData.id,
          meetingStatus: meetingStatus
        });
      }
      if (response) {
        this.setState({
          loadingStatus: false
        });
        const { message, status } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );

          //write logic to update upcomming scheduled pragati agenda flag here
          getUpcommingAgendaFlagDispatch();

          if (meetingStatus === "RESCHEDULE") {
            history.push({
              pathname: PATHS.CREATE_AGENDA,
              state: {
                agendaId: get(response, "data", null)
              }
            });
          }
          if (
            meetingStatus === "CONCLUDED" ||
            meetingStatus === "POSTPONED" ||
            meetingStatus === "CANCELLED"
          ) {
            getMomDetails(undefined, { momId: get(response, "data", null) });
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        this.setState({
          loadingStatus: false
        });
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    }
  };

  downloadMinute = async () => {
    this.setState({ loadingStatus: true });
    const { agendaDetails } = this.props;
    const resp = await downloadMinuteAction(
      undefined,
      get(agendaDetails, "data.id")
    );
    if (resp) {
      this.setState({ loadingStatus: false });
      const { status, data } = resp;
      if (status) {
        window.location.href = get(data, "data");
        toast.success(
          <p className="toast-text-alignment">{ERROR_MSG.DOWNLOAD_SUCCESS}</p>,
          successToastStyle
        );
      } else {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
          errorToastStyle
        );
      }
    }
  };

  sendMinute = async () => {
    this.setState({ loadingStatus: true });
    const { agendaDetails } = this.props;
    const resp = await sendMinuteAction(
      undefined,
      get(agendaDetails, "data.id")
    );
    if (resp) {
      this.setState({ loadingStatus: false });
      const { status } = resp;
      if (status) {
        toast.success(ERROR_MSG.SUCCESS);
      } else {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
          errorToastStyle
        );
      }
    }
  };

  onToggleSummary = event => {
    event && event.preventDefault();
    this.setState(prevState => ({ openSummary: !prevState.openSummary }));
  };

  onToggleEdit = event => {
    event && event.preventDefault();
    this.setState(prevState => ({ openEditPopup: !prevState.openEditPopup }));
  };

  getAgendaStackeHolder = async () => {
    const {
      agendaDetails: {
        data: { id }
      }
    } = this.props;
    return await getAgendaStakeHolderAction(undefined, id);
  };

  onToggleAttachment = fileId => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  onRemoveFile = ({ id }) => {
    try {
      const {
        location,
        getMomDetails,
        agendaDetails: {
          data: { fileDTOList, id: meetingId }
        }
      } = this.props;
      const { agendaId: _agendaId } = queryString.parse(location.search);
      const remaningFiles = fileDTOList
        .filter(value => value.id !== id)
        .map(value => value.id);
      this.setState(
        {
          isremovingfile: true
        },
        async () => {
          const response = await setUpdateMeetingFilesAction(undefined, {
            files: remaningFiles,
            meetingId
          });
          const { data = {} } = response;
          const { status, message } = data;
          //
          if (status) {
            toast.success(
              <p className="toast-text-alignment">
                File is deleted successfully
              </p>,
              successToastStyle
            );
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }

          this.setState(
            {
              isremovingfile: false
            },
            () => {
              if (location.state && location.state.agendaId) {
                const { agendaId } = location.state;
                getMomDetails(undefined, { momId: agendaId });
                this.handleHistory(agendaId);
              } else if (_agendaId) {
                getMomDetails(undefined, { momId: _agendaId });
                this.handleHistory(_agendaId);
              }
            }
          );
        }
      );
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  onSuccessUploadOfAttachmets = async fileDto => {
    try {
      const {
        props: {
          agendaDetails: { data = {} }
        }
      } = this;
      const { id: meetingId, fileDTOList = [] } = data || {};
      await setUpdateMeetingFilesAction(undefined, {
        files: [fileDto.id].concat(fileDTOList.map(value => value.id)),
        meetingId
      });
      this.handleUpdateStatus();
      this.onToggleAttachment();
    } catch (error) {
      console.error(error.message);
    }
  };

  toggleMeetingPopUp = () => {
    this.setState(prevState => ({
      showCommentPopUp: !prevState.showCommentPopUp
    }));
  };

  sendMeetingRequestPayload = () => {
    const {
      agendaDetails,
      sendMeetingRequest,
      location,
      getMomDetails
    } = this.props;
    const { id } = agendaDetails.data || {};
    sendMeetingRequest(request, id).then(resp => {
      if (resp.status) {
        const { agendaId: _agendaId } = queryString.parse(location.search);
        if (location.state) {
          const { agendaId } = location.state;
          getMomDetails(undefined, { momId: agendaId });
        } else if (_agendaId) {
          getMomDetails(undefined, { momId: _agendaId });
        }
      }
    });
    this.toggleMeetingPopUp();
  };
  onPPTChecked = () => {
    const { isPPTChecked } = this.state;
    this.setState({
      isPPTChecked: !isPPTChecked
    });
  };

  deselectProjects = idx => {
    this.setState(
      prevState => {
        const deletedProject = prevState.selectedProjectIssues.splice(idx, 1);
        const issuesNeedToDelete = deletedProject.issuesSelected;

        let updatedSelectedIssues = [];
        updatedSelectedIssues = prevState.selectedProjectIssues.reduce(
          (acc, singleProject) => {
            return acc.concat(singleProject.issuesSelected);
          },
          []
        );

        return {
          deletedProjects: deletedProject,
          selectedProjectIssues: prevState.selectedProjectIssues,
          selectedIssues: updatedSelectedIssues,
          dataUnsaved: true
        };
      },
      () => {
        const { selectedProjectIssues, selectedGuests } = this.state;
        const { guestListDispatch } = this.props;
        //const ids = selectedIssues.map(issue => issue.id);
        const ids = [];
        //calculate payload start
        let projectIds = [];
        let issueIds = [];
        selectedProjectIssues.map(singleProject => {
          const projectSelectedIssues = singleProject.issuesSelected;
          if (
            isValidArray(projectSelectedIssues) &&
            projectSelectedIssues.length > 0
          ) {
            //loop through issues
            projectSelectedIssues.map(issue => {
              issueIds.push(issue.id);
            });
          } else {
            //Add project id in array
            projectIds.push(singleProject.id);
          }
        });
        const params = {
          projectIds,
          issueIds
        };
        //calculate payload end
        guestListDispatch(undefined, params).then(resp => {
          resp && this.filterGuestList(resp.data, selectedGuests);
        });
      }
    );
  };

  deselectIssues = (idx, id) => {
    //console.log("delete issue", idx, id);
    //console.log(`Clicked issue with id `, idx);
    this.setState(
      prevState => {
        const updatedSelectedProjectIssues = prevState.selectedProjectIssues.map(
          singleProject => {
            return {
              ...singleProject,
              issuesSelected: singleProject.issuesSelected.filter(
                item => item.id !== idx
              )
            };
          }
        );
        let updatedSelectedIssues = [];
        updatedSelectedIssues = updatedSelectedProjectIssues.reduce(
          (acc, singleProject) => {
            return acc.concat(singleProject.issuesSelected);
          },
          []
        );

        return {
          selectedProjectIssues: updatedSelectedProjectIssues,
          selectedIssues: updatedSelectedIssues,
          dataUnsaved: true
        };
      },
      () => {
        const {
          selectedIssues,
          selectedProjectIssues,
          selectedGuests
        } = this.state;
        //console.log(selectedIssues);
        const { guestListDispatch } = this.props;
        // const ids = selectedIssues.map(issue => issue.id);
        //calculate payload start
        let projectIds = [];
        let issueIds = [];
        selectedProjectIssues.map(singleProject => {
          const projectSelectedIssues = singleProject.issuesSelected;
          if (
            isValidArray(projectSelectedIssues) &&
            projectSelectedIssues.length > 0
          ) {
            //loop through issues
            projectSelectedIssues.map(issue => {
              issueIds.push(issue.id);
            });
          } else {
            //Add project id in array
            projectIds.push(singleProject.id);
          }
        });
        const params = {
          projectIds,
          issueIds
        };
        //calculate payload end
        const ids = [];
        guestListDispatch(undefined, params).then(resp => {
          resp && this.filterGuestList(resp.data, selectedGuests);
        });
      }
    );
  };

  filterGuestList = (newGuestList = [], selectedGuests) => {
    let guestUserIdArray = [];
    newGuestList.map(item => guestUserIdArray.push(item.userId));
    this.setState({
      selectedGuests:
        selectedGuests &&
        selectedGuests.filter(
          item =>
            item.userAddedGuest ||
            [...new Set(guestUserIdArray)].includes(item.userId)
        )
    });
  };

  closeAddIssueModal = () => {
    this.setState({ isAddIssueModalVisible: false });
  };

  closeAddProjectModal = () => {
    this.setState({ isAddProjectModalVisible: false });
  };

  showAddIssueModal = (data, result) => {
    this.setState({
      isAddIssueModalVisible: true,
      result: result
    });
  };

  showAddProjectModal = (data, result) => {
    this.setState({
      isAddProjectModalVisible: true,
      result: result
    });
  };

  openUploadPopup = isCustom => {
    this.setState({
      toggleUploadDisplay: true,
      isCustom: isCustom
    });
  };

  closeUploadPopup = () => {
    this.setState({ toggleUploadDisplay: false });
  };

  addProjectIssuesToAgenda = selectedProjectIssues => {
    console.log("In addProjectIssuesToAgenda", selectedProjectIssues);
    this.setState(prevState => {
      const projectArr = [];
      let selectedIssuesArr = [];
      selectedProjectIssues.forEach(currentProject => {
        const selectedIssues = currentProject.issuesSelected;
        selectedIssuesArr = [...selectedIssuesArr, ...selectedIssues];
      });
      console.log("before return In addProjectIssuesToAgenda");
      return {
        isAddIssueModalVisible: false,
        isAddProjectModalVisible: false,
        selectedProjectIssues: selectedProjectIssues,
        selectedIssues: selectedIssuesArr,
        dataUnsaved: true,
        showUploadedResultModal: false
      };
    });
  };

  closeUploadedListModal = () => {
    this.setState({ showUploadedResultModal: false });
  };

  closeUploadErrorModal = () => {
    this.setState({ showUploadErrorModal: false });
  };
  handleDownload = async () => {
    this.setState({ displayExcelIcon: false, displayLoader: true });
    const response = await request(_downloadUploadAgendaTemplate());
    if (response) {
      this.setState({
        displayLoader: false,
        downloadExcelTemplate: response.data.data
      });
    }
  };
  handleDownloadExcel = async () => {
    window.location.href = this.state.downloadExcelTemplate;
    this.setState({ displayExcelIcon: true, downloadExcelTemplate: "" });
  };
  renderDownloadTemplateBlock() {
    return (
      <div className="download-section">
        <hr />
        <div className="add-issue-subdesc-downld">
          Download Template :{" "}
          <div
            className="download-excel-component upload-agenda"
            style={{ border: "none" }}
          >
            {this.state.displayExcelIcon ? (
              <span className="download-excel-component">
                <span className="download-mis-file download-icon">
                  <span
                    className="download-icons-excel"
                    onClick={this.handleDownload}
                  />
                </span>
              </span>
            ) : null}

            {this.state.displayLoader ? (
              <span class="download-excel-component  ">
                <span class="download-icon downloading">
                  <span class="download-icons-excel" />
                  <span
                    role="status"
                    aria-hidden="true"
                    class="spinner-border spinner-border-sm"
                  />
                </span>
              </span>
            ) : null}
            {this.state.downloadExcelTemplate != "" ? (
              <span
                class="download-excel-component  "
                onClick={this.handleDownloadExcel}
              >
                <span class="download-icon agenda-download-ppt-icon">
                  <FontAwesomeIcon
                    icon={faDownload}
                    size="2x"
                    onClick={this.handleDownloadExcel}
                    style={{ height: "18px", width: "18px" }}
                  />
                </span>
              </span>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
  render() {
    const user = getLocalstorage("user");
    const isUserPMG = getLocalstorage("groupCategory") === "PMG";
    const {
      momDetailsStatus,
      agendaDetails,
      location,
      permission,
      agendaMeetingPptv2,
      downloadAgendaMeetingPptv2,
      clearDownloadAgendaMeetingPptv2Action,
      agendaMeetingPpt,
      agendaMeetingCabSecPpt,
      downloadAgendaMeetingPpt,
      downloadAgendaCabSecPpt,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      agendaMeetingExcel,
      downloadAgendaMeetingExcel,
      clearDownloadAgendaMeetingExcelAction,
      getAgendaSummary,
      agendaSummaryData,
      agendaSummaryStatus,
      agendaMeetingPptv2WithoutIssue,
      clearDownloadAgendaMeetingPptv2WithoutIssueAction,
      downloadAgendaMeetingPptv2PragatiFormat,
      clearDownloadAgendaMeetingPptv2PragatiFormatAction,
      agendaMeetingPptv2PragatiFormat,
      uploadAgendaTmp,
      downloadUpdaloadAgendaTemplateAction
    } = this.props;
    const {
      history,
      isremovingfile,
      loadingStatus,
      openSummary,
      openEditPopup,
      showCommentPopUp,
      toggleAttachementDisplay,
      isConfirmModalVisible,
      agendaMeetingTypeDetails,
      isPPTChecked,
      selectedProjectIssues,
      selectedIssues,
      isAddIssueModalVisible,
      isAddProjectModalVisible,
      deletedProjects,
      dataRecipient,
      toggleUploadDisplay,
      showUploadedResultModal,
      isCustom,
      showUploadErrorModal
    } = this.state;
    const {
      onRemoveFile,
      onToggleSummary,
      onToggleEdit,
      getAgendaStackeHolder,
      handleUpdateStatus,
      onToggleAttachment,
      onSuccessUploadOfAttachmets,
      onPPTChecked,
      setRecipientChange,
      handleRecipientClose
    } = this;

    let agendaData = null;
    if (agendaDetails && agendaDetails.data) {
      agendaData = agendaDetails.data;
    }
    const agendaStatus = get(agendaData, "meetingStatus", null);

    const isGuestnotDisplayusers =
      get(user, "groupCategory") == "CENTRAL" ||
      get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
      get(user, "groupCategory") == "STATE";
    const mode =
      get(agendaData, "meetingMode") &&
      MEETING_OPTION[get(agendaData, "meetingMode")];

    const isFirefoxBrowser = /Firefox/i.test(navigator.userAgent);

    return (
      <React.Fragment>
        <LoaderPage
          loading={
            momDetailsStatus === STATUS.LOADING ||
            agendaSummaryStatus === STATUS.LOADING ||
            loadingStatus ||
            isremovingfile
          }
        />
        {openSummary ? (
          <AgendaCardInfo
            agendaDetails={get(agendaDetails, "data")}
            onClose={onToggleSummary}
          />
        ) : (
          <React.Fragment />
        )}
        {openEditPopup ? (
          <EditAgenda
            formData={get(agendaDetails, "data")}
            onClose={onToggleEdit}
            getInitialCalls={this.getInitialCalls}
            agendaMeetingTypeDetails={agendaMeetingTypeDetails}
          />
        ) : (
          <React.Fragment />
        )}

        {showCommentPopUp ? (
          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal"}
            saveHandler={this.sendMeetingRequestPayload}
            closeHandler={this.toggleMeetingPopUp}
            content={"Are you sure you want to do this?"}
          />
        ) : null}

        {isConfirmModalVisible ? (
          <ConfirmationComponent
            show={isConfirmModalVisible}
            content={
              agendaSummaryData && agendaSummaryData.data ? (
                <React.Fragment>
                  <table className="table table-striped table-bordered agenda-summary-table">
                    <thead style={{ textAlign: "center" }}>
                      {/* <tr>
                        <th>Issue with Decision Count</th>
                        <th>Task Completion Date Count</th>
                      </tr> */}
                      <tr>
                        <th>Projects with Decision</th>
                        <th>Issues with Decision</th>
                        <th>Issues with Resolution Date</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {/* <tr>
                        <td>{agendaSummaryData.data.decisionCount}</td>
                        <td>{agendaSummaryData.data.taskCompletionCount}</td>
                      </tr> */}
                      <tr>
                        <td>
                          {agendaSummaryData.data.projectsWithDecisions}/
                          {agendaSummaryData.data.totalProjects}
                        </td>
                        <td>
                          {agendaSummaryData.data.issuesWithDecisions}/
                          {agendaSummaryData.data.totalIssues}
                        </td>
                        <td>
                          {agendaSummaryData.data.issuesWithResolutionDate}/
                          {agendaSummaryData.data.totalIssues}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p>Are you sure you want to conclude this agenda?</p>
                </React.Fragment>
              ) : (
                "Are you sure?"
              )
            }
            modalClass={"confirmation-modal projectModalBox"}
            saveHandler={() =>
              this.setState({ isConfirmModalVisible: false }, () =>
                this.changeMeetingStatus("CONCLUDED")
              )
            }
            closeHandler={() => this.setState({ isConfirmModalVisible: false })}
          />
        ) : null}

        <Container className="agenda-detail-container">
          {get(agendaDetails, "data") ? (
            <React.Fragment>
              <Row>
                <Col>
                  <div className="agenda-detail">
                    <React.Fragment>
                      <div className="agenda-details-title">
                        <h3 className="">Agenda Details</h3>
                      </div>
                      <div className="agenda-details agenda-details-id justify-content-start">
                        <div className="agenda-list-title">
                          AGENDA ID{" "}
                          <span className="agenda-id">
                            #{get(agendaData, "id", null)}
                          </span>{" "}
                          |{" "}
                          <span className="agenda-total">
                            {get(agendaData, "projectCount", null)} Project(s) &{" "}
                            {get(agendaData, "issueCount", null)} Issue(s)
                          </span>
                        </div>
                        <div
                          className={`${getAgendaTagsColor(
                            get(agendaData, "meetingStatus", null)
                          )} project-stage-background ml-3`}
                        >
                          <div
                            className={`project-stage`}
                            data-test="project-stage"
                          >
                            <div>{get(agendaData, "meetingStatus", null)}</div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div
                          className={`${
                            isFirefoxBrowser ? "fireFox" : "agenda-contents"
                          }`}
                        >
                          <h3 className="agenda-name">
                            {get(agendaData, "agendaName", null)}
                          </h3>
                          <div className="agenda-wrapper">
                            <div className="agenda-horizontal-view">
                              <div className="agenda-horizontal-view-left">
                                <div className="agenda-detail-info meeting-when">
                                  <span className="agenda-icon-padding">
                                    <Image src={Calendar} alt="Plus Icon" />
                                  </span>
                                  <span>
                                    <b>When</b>
                                    {getDayOfTheGivenDate(
                                      get(agendaData, "meetingDate", null)
                                    ) +
                                      ", " +
                                      dateFormat(
                                        get(agendaData, "meetingDate", null)
                                      )}
                                    {", "}
                                    {getTimeOfTheGivenDate(
                                      get(agendaData, "meetingTimeFrom", null)
                                    )}
                                  </span>
                                </div>
                                <div className="agenda-detail-info">
                                  <span className="agenda-icon-padding">
                                    <Image src={Venue} alt="Plus Icon" />
                                  </span>
                                  <span>
                                    <b>Venue</b>
                                    <p className="Agenda-content">
                                      {get(agendaData, "venueName", null)}
                                    </p>
                                  </span>
                                </div>
                                <div className="agenda-detail-info">
                                  <span className="agenda-icon-padding">
                                    <Image src={Meeting} alt="Plus Icon" />
                                  </span>
                                  <span>
                                    <b>Meeting Type</b>
                                    <p className="Agenda-content">
                                      {get(agendaData, "meetingType", null) ||
                                        "NA"}
                                    </p>
                                  </span>
                                </div>
                              </div>
                              <div className="agenda-horizontal-view-left">
                                <div className="agenda-detail-info pr-4">
                                  <span className="agenda-icon-padding">
                                    <Image src={ChairedBy} />
                                  </span>
                                  <span>
                                    <b>Chaired By</b>
                                    {get(agendaData, "meetingChairedBy", null)}
                                  </span>
                                </div>
                                <div className="agenda-detail-info">
                                  {get(agendaData, "meetingMode") ? (
                                    <>
                                      <span className="agenda-icon-padding">
                                        <Image src={MeetingModeIcon} />
                                      </span>
                                      <span>
                                        <b>Meeting Mode</b>
                                        <p className="Agenda-content">{mode}</p>
                                      </span>
                                    </>
                                  ) : null}
                                </div>
                                <div className="agenda-detail-info agenda-sent-from">
                                  <span className="agenda-icon-padding">
                                    <Image src={AgendaSentIcon} />
                                  </span>
                                  <span>
                                    <b>Agenda Sent From</b>
                                    <p className="Agenda-content">
                                      {get(
                                        agendaData,
                                        "agendaSentFromName",
                                        null
                                      )}
                                    </p>
                                  </span>
                                </div>
                              </div>
                              <div className="agenda-horizontal-view-left">
                                <div>
                                  {get(agendaData, "meetingStatus") !==
                                  "CONCLUDED" ? (
                                    <div className="agenda-sent-from">
                                      {isValidArray(
                                        get(agendaData, "fileDTOList")
                                      ) ? (
                                        <div>
                                          <b className="title attachment-title">
                                            Attachment
                                          </b>
                                          <DisplayAttachments
                                            filesArr={get(
                                              agendaData,
                                              "fileDTOList"
                                            )}
                                            addAttchementRequired={false}
                                            removeRequired={false}
                                            classes="attachments"
                                            agendadetailcss={true}
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="agenda-details-btn">
                          <DisplayByPermission
                            display={
                              get(permission, "updateAllAgendaSuperPMG") &&
                              !get(permission, "canViewOnlyProject")
                            }
                          >
                            <Button
                              className={"agenda-btn-summary"}
                              onClick={this.onToggleEdit}
                            >
                              Edit
                            </Button>
                            {get(agendaData, "meetingStatus") === "SCHEDULED" &&
                            get(agendaData, "issueCount") > 0 ? (
                              <div className="last-date-wrapper">
                                {get(agendaData, "lastSentMeetingReminder") ? (
                                  <TooltipComponent
                                    classes="create_project_tolltip"
                                    content={
                                      <>
                                        Last sent on :{" "}
                                        {dateFormatWithTime(
                                          get(
                                            agendaData,
                                            "lastSentMeetingReminder",
                                            null
                                          ),
                                          "LLL"
                                        )}
                                      </>
                                    }
                                  />
                                ) : null}
                                <Button
                                  className={"agenda-btn-summary"}
                                  onClick={this.toggleMeetingPopUp}
                                >
                                  Send Meeting Reminder
                                </Button>
                              </div>
                            ) : null}
                          </DisplayByPermission>
                          <Button
                            className="agenda-btn-summary btn-blue-invert"
                            variant="info"
                            size="sm"
                            onClick={e => {
                              onToggleSummary(e);
                            }}
                          >
                            Agenda Summary
                          </Button>
                          <div />
                          {get(agendaData, "meetingStatus") === "SCHEDULED" ? (
                            <div className="download-options">
                              <DownloadUploadComponent
                                meetingId={get(agendaData, "id")}
                                callApiOnSuccess={handleUpdateStatus}
                                permission={permission}
                                dataAssignee={setRecipientChange}
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {get(agendaData, "meetingStatus") &&
                      get(agendaData, "meetingStatus") !== "DRAFT" &&
                      history.length > 1 ? (
                        <div className="agenda-postponed-data-wrapper">
                          <h3>History ({history.length})</h3>
                          <div className="agenda-postponed-data">
                            <ul>
                              {history.map((list, index) => (
                                <li key={index}>
                                  <div className="agenda-postponed">
                                    <div>
                                      Agenda{" "}
                                      <span
                                        className="history-link"
                                        onClick={() =>
                                          this.handleAgendaHistory(
                                            list.meetingId
                                          )
                                        }
                                      >
                                        #{list.meetingId}
                                      </span>{" "}
                                      | {dateFormat(list.meetingDate)}
                                    </div>
                                    <div className="postponed-on">
                                      {list.status
                                        ? `${list.status.toLowerCase()} on`
                                        : "Postponed on"}{" "}
                                      {dateFormat(list.postponeDate)}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                      <div className="agenda-created-on">
                        Created by{" "}
                        <span>{get(agendaData, "meetingCreatedBy", null)}</span>{" "}
                        on{" "}
                        <span>
                          {getDayOfTheGivenDate(
                            get(agendaData, "agendaCreatedOn", null)
                          ) +
                            ", " +
                            dateFormat(
                              get(agendaData, "agendaCreatedOn", null)
                            )}
                          {", "}
                          {getTimeOfTheGivenDate(
                            get(agendaData, "agendaCreatedOn", null)
                          )}
                        </span>
                      </div>
                    </React.Fragment>
                  </div>
                </Col>
              </Row>
              <DisplayByPermission
                display={!get(permission, "canViewOnlyProject")}
              >
                {get(agendaData, "meetingStatus") === "CONCLUDED" ? (
                  <div className="agenda-details-issues agenda-detail-attach-documents">
                    <h3 className="agenda-issues-heading">Attachment(s)</h3>

                    <DisplayAttachments
                      isAgendaAttachment={true}
                      onTogglePopUp={onToggleAttachment}
                      filesArr={get(agendaData, "fileDTOList")}
                      onRemoveFile={onRemoveFile}
                      agendadetailcss={true}
                    />
                    {toggleAttachementDisplay ? (
                      <UploadAttachmentsWithTitleComponent
                        agendaData={agendaData}
                        displayModal={toggleAttachementDisplay}
                        onCloseModal={onToggleAttachment}
                        fileFormats={
                          get(agendaData, "meetingStatus") === "CONCLUDED"
                            ? DOCUMENT_FORMATS_FOR_CONCLUDED_AGENDA
                            : DOCUMENT_FORMATS
                        }
                        //fileFormats={DOCUMENT_FORMATS_AGENDA}
                        onSubmit={onSuccessUploadOfAttachmets}
                        forFileSize={true}
                        concludedAgenda={
                          get(agendaData, "meetingStatus") === "CONCLUDED"
                        }
                      />
                    ) : null}
                  </div>
                ) : null}
              </DisplayByPermission>
              <DisplayByPermission display={isAddProjectModalVisible}>
                <SelectProject
                  show={isAddProjectModalVisible}
                  closeModal={this.closeAddProjectModal}
                  selectedProjects={selectedProjectIssues}
                  //closeIssueModal={this.closeAddIssueModal}
                  selectedIssues={selectedIssues}
                  submitHandler={this.addProjectIssuesToAgenda}
                  deletedProjects={deletedProjects}
                  //resetSelectedIssues={this.resetSelectedIssues}
                />
              </DisplayByPermission>
              {toggleUploadDisplay ? (
                <UploadProjectsIssuesComponent
                  key={toggleUploadDisplay}
                  onUploadToggle={this.closeUploadPopup}
                  toggleUploadDisplay={toggleUploadDisplay}
                  isCustom={isCustom}
                  customSection={this.renderDownloadTemplateBlock()}
                  uploadedProjectissues={selectedProjectIssues}
                />
              ) : null}
              {showUploadedResultModal && (
                <UploadedListModal
                  show={showUploadedResultModal}
                  closeModal={this.closeUploadedListModal}
                  addInAgenda={this.addProjectIssuesToAgenda}
                  alreadySelected={selectedProjectIssues}
                />
              )}
              {showUploadErrorModal && (
                <UploadErrorModal
                  show={showUploadErrorModal}
                  closeModal={this.closeUploadErrorModal}
                  addInAgenda={this.addProjectIssuesToAgenda}
                />
              )}
              {/* {isValidArray(selectedProjectIssues) ? ( */}
              <div className="agenda-details-issues">
                <h3 className="page-orange-bar">
                  Projects{" "}
                  {isValidArray(selectedProjectIssues) ? (
                    <span>({selectedProjectIssues.length})</span>
                  ) : (
                    <span>(0)</span>
                  )}{" "}
                  & Issues{" "}
                  {isValidArray(selectedIssues) ? (
                    <span>({selectedIssues.length})</span>
                  ) : (
                    <span>(0)</span>
                  )}
                </h3>
                <div className="addissue-heading-wrapper-draft">
                  {isValidArray(selectedProjectIssues) ? (
                    <div className="page-orange-bar-right">
                      {get(user, "groupCategory") === "PMG" && (
                        <div className="agenda-issues-button-wrapper">
                          <div className="agenda-ppt-v3">
                            <AgendaDropdown
                              customStyle={true}
                              selected={
                                this.state.selectedValue
                                  ? this.state.selectedValue
                                  : { title: "Select" }
                              }
                              options={DROP_DOWN_VALUES}
                              onSelect={value =>
                                this.handleDropdownSelect(value)
                              }
                              isDraft={true}
                              isPMG={true}
                            />
                            {!this.state.selectedValue ||
                            this.state.selectedValue.title === "" ? (
                              <div className="disabled-ppt1">
                                <img
                                  sizes="10px"
                                  src={DisabledPPt}
                                  variant="outline-info"
                                />
                              </div>
                            ) : this.state.selectedValue.title ===
                              "Monitoring Group" ? (
                              <div
                                className={
                                  get(user, "groupCategory") === "PMG"
                                    ? "agenda-ppt-v3"
                                    : ""
                                }
                              >
                                <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingPpt &&
                                    agendaMeetingPpt.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingPpt &&
                                    agendaMeetingPpt.downloadingSrc
                                  }
                                  onClearDownload={() =>
                                    clearDownloadAgendaMeetingPptAction()
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaMeetingPpt(
                                      get(agendaData, "id")
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                  isPMG={true}
                                />
                              </div>
                            ) : this.state.selectedValue.title ===
                              "With issue status" ? (
                              <>
                                <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingPptv2 &&
                                    agendaMeetingPptv2.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingPptv2 &&
                                    agendaMeetingPptv2.downloadingSrc
                                  }
                                  onClearDownload={
                                    clearDownloadAgendaMeetingPptv2Action
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaMeetingPptv2(
                                      get(agendaData, "id"),
                                      false,
                                      true
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                  isPMG={true}
                                />
                              </>
                            ) : this.state.selectedValue.title ===
                              "Without issue status" ? (
                              <>
                                <div>
                                  <DownloadExcelReport
                                    border={true}
                                    isLoading={
                                      agendaMeetingPptv2WithoutIssue &&
                                      agendaMeetingPptv2WithoutIssue.isLoading
                                    }
                                    downloadLink={
                                      agendaMeetingPptv2WithoutIssue &&
                                      agendaMeetingPptv2WithoutIssue.downloadingSrc
                                    }
                                    onClearDownload={() =>
                                      clearDownloadAgendaMeetingPptv2WithoutIssueAction()
                                    }
                                    onStartDownloading={() =>
                                      downloadAgendaMeetingPptv2(
                                        get(agendaData, "id"),
                                        false,
                                        false
                                      )
                                    }
                                    onDownloadLinkClick={
                                      this.handleDownloadLinkClick
                                    }
                                    iconClassName="ppt-icon"
                                    isDraft={true}
                                    isPMG={true}
                                  />
                                </div>
                              </>
                            ) : this.state.selectedValue.title ===
                              "PRAGATI Format" ? (
                              <>
                                <div>
                                  <DownloadExcelReport
                                    border={true}
                                    isLoading={
                                      agendaMeetingPptv2PragatiFormat &&
                                      agendaMeetingPptv2PragatiFormat.isLoading
                                    }
                                    downloadLink={
                                      agendaMeetingPptv2PragatiFormat &&
                                      agendaMeetingPptv2PragatiFormat.downloadingSrc
                                    }
                                    onClearDownload={() =>
                                      clearDownloadAgendaMeetingPptv2PragatiFormatAction()
                                    }
                                    onStartDownloading={() =>
                                      downloadAgendaMeetingPptv2PragatiFormat(
                                        get(agendaData, "id")
                                      )
                                    }
                                    onDownloadLinkClick={
                                      this.handleDownloadLinkClick
                                    }
                                    iconClassName="ppt-icon"
                                    isDraft={true}
                                    isPMG={true}
                                  />
                                </div>
                              </>
                            ) : this.state.selectedValue.title ===
                              "CabSec format" ? (
                              <>
                                <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingCabSecPpt &&
                                    agendaMeetingCabSecPpt.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingCabSecPpt &&
                                    agendaMeetingCabSecPpt.downloadingSrc
                                  }
                                  onClearDownload={
                                    clearDownloadAgendaMeetingCabSecPptAction
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaCabSecPpt(
                                      get(agendaData, "id")
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                  isPMG={true}
                                />
                              </>
                            ) : null}
                          </div>
                        </div>
                      )}

                      {get(user, "groupCategory") !== "PMG" && (
                        <div>
                          <DownloadExcelReport
                            // isLoading={
                            //   agendaMeetingPpt && agendaMeetingPpt.isLoading
                            // }
                            // downloadLink={
                            //   agendaMeetingPpt &&
                            //   agendaMeetingPpt.downloadingSrc
                            // }
                            // onClearDownload={() =>
                            //   clearDownloadAgendaMeetingPptAction()
                            // }
                            // onStartDownloading={() =>
                            //   downloadAgendaMeetingPpt(get(agendaData, "id"))
                            // }
                            // onDownloadLinkClick={this.handleDownloadLinkClick}
                            isLoading={
                              agendaMeetingPptv2 && agendaMeetingPptv2.isLoading
                            }
                            downloadLink={
                              agendaMeetingPptv2 &&
                              agendaMeetingPptv2.downloadingSrc
                            }
                            onClearDownload={
                              clearDownloadAgendaMeetingPptv2Action
                            }
                            onStartDownloading={() =>
                              downloadAgendaMeetingPptv2(
                                get(agendaData, "id"),
                                false,
                                true
                              )
                            }
                            onDownloadLinkClick={this.handleDownloadLinkClick}
                            iconClassName="ppt-icon"
                            isDraft={true}
                            isPMG={false}
                          />
                        </div>
                      )}

                      <div className="agenda-meeting-excel">
                        <DownloadExcelReportAgenda
                          isLoading={
                            agendaMeetingExcel && agendaMeetingExcel.isLoading
                          }
                          downloadLink={
                            agendaMeetingExcel &&
                            agendaMeetingExcel.downloadingSrc
                          }
                          onClearDownload={() =>
                            clearDownloadAgendaMeetingExcelAction()
                          }
                          onStartDownloading={() =>
                            downloadAgendaMeetingExcel(get(agendaData, "id"))
                          }
                          isDraft={true}
                        />
                      </div>
                      {get(agendaData, "meetingStatus", null) ===
                      "SCHEDULED" ? (
                        <div className="agenda-meeting-doc">
                          <DownloadAgendaByType id={get(agendaData, "id")} />
                        </div>
                      ) : null}

                      <DownloadAgendaParticipants
                        id={get(agendaData, "id")}
                        isDraft={true}
                      />
                      <DisplayByPermission
                        display={
                          !get(permission, "canViewOnlyProject") &&
                          (get(user, "groupCategory") === "PMG" ||
                            get(user, "groupCategory") === "STATE_PMG")
                        }
                      >
                        <SendByComponent1
                          meetingId={get(agendaData, "id", null)}
                          containerClass="send_notification agenda-details-compose-button"
                          getStakeHolders={getAgendaStackeHolder}
                          notificationCO={{ momFacetsCO: {} }}
                          customNotificationType="AGENDA"
                          style={"pr-4"}
                        />
                      </DisplayByPermission>

                      {get(agendaData, "meetingStatus", null) ===
                      "SCHEDULED" ? (
                        <DisplayByPermission
                          display={
                            get(permission, "updateAllAgendaSuperPMG") &&
                            !get(permission, "canViewOnlyProject")
                          }
                        >
                          {/* <Button
                            className="btn-blue-invert no-padding1"
                            onClick={this.showAddProjectModal}
                          >
                            <span>+</span> Add Project(s) & Issue(s)
                          </Button> */}
                          <Dropdown>
                            <Dropdown.Toggle
                              as={Button}
                              bsPrefix="btn-blue-invert no-padding1"
                              id="add-project-dropdown"
                            >
                              <span>+</span> Add Project(s) & Issue(s)
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item
                                className="agenda-custom-color"
                                onClick={this.showAddProjectModal}
                                style={{ fontSize: 15, fontFamily: "mpsb" }}
                              >
                                Add Manually
                              </Dropdown.Item>

                              <Dropdown.Item
                                className="agenda-custom-color"
                                onClick={() => this.openUploadPopup(true)}
                                style={{ fontSize: 15, fontFamily: "mpsb" }}
                              >
                                Upload Excel File
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </DisplayByPermission>
                      ) : null}
                    </div>
                  ) : get(agendaData, "meetingStatus", null) === "SCHEDULED" ? (
                    <DisplayByPermission
                      display={
                        get(permission, "updateAllAgendaSuperPMG") &&
                        !get(permission, "canViewOnlyProject")
                      }
                    >
                      {/* <Button
                        className="btn-blue-invert no-padding1"
                        onClick={this.showAddProjectModal}
                      >
                        <span>+</span> Add Project(s) & Issue(s)
                      </Button> */}
                      <Dropdown style={{ marginLeft: "auto" }}>
                        <Dropdown.Toggle
                          as={Button}
                          bsPrefix="btn-blue-invert no-padding1"
                          id="add-project-dropdown"
                        >
                          <span>+</span> Add Project(s) & Issue(s)
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            className="agenda-custom-color"
                            onClick={this.showAddProjectModal}
                            style={{ fontSize: 15, fontFamily: "mpsb" }}
                          >
                            Add Manually
                          </Dropdown.Item>

                          <Dropdown.Item
                            className="agenda-custom-color"
                            onClick={() => this.openUploadPopup(true)}
                            style={{ fontSize: 15, fontFamily: "mpsb" }}
                          >
                            Upload Excel File
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </DisplayByPermission>
                  ) : null}
                </div>
                {isValidArray(selectedProjectIssues) ? (
                  <div className="added-issue-list added-project-issue-list">
                    {(selectedProjectIssues || []).map((itemProject, index) => (
                      <ProjectIssueSingle
                        project={itemProject}
                        idx={index}
                        key={index}
                        deleteHandler={this.deselectProjects}
                        deleteIssueHandler={this.deselectIssues}
                        //fromCreateAgendaPage={true}
                        agendaData={agendaData}
                        handleUpdateStatus={this.handleUpdateStatus}
                        permission={permission}
                        meetingStatus={agendaStatus}
                        fromAgendaDetailPage={true}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="no-data-wrapper">
                    <div className="img-container">
                      <img src={NoDataFoundIcon} alt="No Data" />
                      <h3 className={`no-data-found`}>
                        No Projects or Issues Added
                      </h3>
                    </div>
                  </div>
                )}
              </div>
              {/* ) : null} */}
              {isGuestnotDisplayusers ? null : (
                <div className="decision-guest">
                  <h3>Guests</h3>
                  <div className="guest-list-wrapper">
                    <div className="agenda-guest-wrapper">
                      <GuestList
                        users={get(agendaData, "users", [])}
                        guests={get(agendaData, "guests", [])}
                      />
                    </div>
                  </div>
                </div>
              )}

              {get(agendaData, "meetingStatus", null) === "POSTPONED" &&
              !get(agendaData, "isReschedule") ? (
                <DisplayByPermission
                  display={!get(permission, "canViewOnlyProject")}
                >
                  <ButtonToolbar className="agenda-btn-container">
                    <Link
                      to={{
                        pathname: PATHS.CREATE_AGENDA,
                        state: {
                          agendaId: get(agendaData, "id", null),
                          reSchedule: true
                        }
                      }}
                    >
                      <Button className="btn-orange no-padding meeting-concluded">
                        RESCHEDULE AGENDA
                      </Button>
                    </Link>
                  </ButtonToolbar>
                </DisplayByPermission>
              ) : null}
              {get(agendaData, "meetingStatus", null) === "CONCLUDED" ? (
                <ButtonToolbar className="agenda-btn-container">
                  <Button
                    className="btn-orange no-padding meeting-concluded"
                    onClick={e => {
                      e.stopPropagation();
                      this.downloadMinute();
                    }}
                  >
                    DOWNLOAD MINUTES
                  </Button>
                  <DisplayByPermission
                    display={!get(permission, "canViewOnlyProject")}
                  >
                    <span
                      style={{
                        display:
                          get(user, "groupCategory") == "STATE_PMG" ||
                          get(user, "groupCategory") == "CENTRAL" ||
                          get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
                          get(user, "groupCategory") == "STATE"
                            ? "none"
                            : null
                      }}
                    >
                      <TooltipComponent
                        classes="create_project_tolltip"
                        content={
                          <>
                            Minutes of meeting will be shared with respective
                            stakeholders only.
                          </>
                        }
                      />
                      <Button
                        className="btn-orange no-padding margin-right-zero"
                        onClick={e => {
                          e.stopPropagation();
                          this.sendMinute();
                        }}
                      >
                        SEND MINUTES
                      </Button>
                    </span>
                  </DisplayByPermission>
                </ButtonToolbar>
              ) : null}
              {get(agendaData, "meetingStatus", null) === "SCHEDULED" ? (
                <ButtonToolbar
                  className={`agenda-btn-container ${
                    !get(permission, "canViewOnlyProject")
                      ? "d-flex justify-content-end"
                      : "d-flex justify-content-between float-right"
                  }`}
                >
                  <DisplayByPermission
                    display={
                      (get(permission, "createRole") &&
                        !get(permission, "canViewOnlyProject")) ||
                      (get(user, "groupCategory") == "STATE_PMG" ||
                        get(user, "groupCategory") == "CENTRAL" ||
                        get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
                        get(user, "groupCategory") == "STATE")
                    }
                  >
                    <Button
                      className="btn-orange no-padding meeting-concluded"
                      onClick={e => {
                        e.stopPropagation();
                        getAgendaSummary(get(agendaData, "id")).then(resp => {
                          resp &&
                            this.setState({
                              isConfirmModalVisible: true
                            });
                        });
                      }}
                    >
                      MEETING CONCLUDED
                    </Button>
                    <Button
                      className="btn-blue no-padding"
                      onClick={e => {
                        e.stopPropagation();
                        this.changeMeetingStatus("POSTPONED");
                      }}
                    >
                      MEETING POSTPONED
                    </Button>
                    <Button
                      className="btn-orange-invert no-padding meeting-cancelled"
                      onClick={e => {
                        e.stopPropagation();
                        this.changeMeetingStatus("CANCELLED");
                      }}
                    >
                      MEETING CANCELLED
                    </Button>
                  </DisplayByPermission>
                  {/* <DownloadAgendaBrief id={get(agendaData, "id")} />
                  <DownloadAgenda id={get(agendaData, "id")} /> */}
                  <DisplayByPermission
                    display={
                      get(permission, "updateAllAgendaSuperPMG") &&
                      !get(permission, "canViewOnlyProject")
                    }
                  >
                    <Button
                      className="save-changes"
                      onClick={e => {
                        e.stopPropagation();
                        this.saveChanges();
                      }}
                    >
                      <img
                        src={saveChangesWhite}
                        className="save-changes-img"
                      />
                      <img
                        src={saveChangesOrange}
                        className="save-changes-img-hover"
                      />
                      SAVE CHANGES
                    </Button>
                  </DisplayByPermission>
                </ButtonToolbar>
              ) : null}
            </React.Fragment>
          ) : null}
          <Modal
            show={this.state.changedRecipientToggle}
            onHide={handleRecipientClose}
            id="add-decision-modal"
            className="confirmation-modal modal-recipient"
          >
            <div class="confirm-icon" />
            <Modal.Header closeButton />
            <Modal.Body>
              <h4 class="page-heading" style={{ fontSize: "19px" }}>
                Primary Recipient Changed for following issues:
              </h4>
              <p>
                {(dataRecipient || []).map((data, index) => (
                  <span
                    key={`list-key-${index}`}
                    style={{ fontSize: "13px", color: "#525252" }}
                  >
                    ISSUE #{data}
                    {dataRecipient.length - 1 !== index ? ", " : ""}
                  </span>
                )) || "NA"}
              </p>
              <p style={{ color: "red", fontSize: "14px" }}>
                Please ensure to update the Secondary Recipient if applicable.
              </p>
            </Modal.Body>
            <div className="add-desicion-btn edit-project-iig-buttons justify-content-end d-flex">
              <div>
                <Button
                  style={{ width: "181px", height: "41px" }}
                  className=" btn-orange no-padding"
                  onClick={handleRecipientClose}
                >
                  Continue
                </Button>
              </div>
            </div>
          </Modal>
        </Container>
      </React.Fragment>
    );
  }
}

AgendaDetails.propTypes = {
  history: PropTypes.shape({}),
  location: PropTypes.shape({})
};

AgendaDetails.defaultProps = {
  history: {},
  location: {}
};

function mapStateToProps(state) {
  return {
    agendaDetails: state.momReducer.data,
    momDetailsStatus: state.momReducer.momDetailsStatus,
    agendaSummaryData: state.momReducer.agendaSummaryData,
    agendaSummaryStatus: state.momReducer.agendaSummaryStatus,
    isApiLoading: state.addDecisionReducer.isApiLoading,
    agendaMeetingPptv2: state.donwloadExcelReducer.agendaMeetingPptv2,
    agendaMeetingPpt: state.donwloadExcelReducer.agendaMeetingPpt,
    agendaMeetingCabSecPpt: state.donwloadExcelReducer.agendaMeetingCabSecPpt,
    agendaMeetingExcel: state.donwloadExcelReducer.agendaMeetingExcel,
    agendaMeetingPptv2WithoutIssue:
      state.donwloadExcelReducer.agendaMeetingPptv2WithoutIssue,
    agendaMeetingPptv2PragatiFormat:
      state.donwloadExcelReducer.agendaMeetingPptv2PragatiFormat,
    uploadAgendaTmp: state.donwloadExcelReducer.uploadAgendaTmp,
    uploadedList: state.donwloadExcelReducer.uploadProjectIssues.uploadedList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMomDetails: getMomDetails,
      updateMom: updateMom,
      sendMeetingRequest: sendMeetingRequest,
      guestListDispatch: guestListAction,
      downloadAgendaMeetingPptv2,
      clearDownloadAgendaMeetingPptv2Action,
      downloadAgendaMeetingPpt,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      getAgendaSummary,
      downloadAgendaMeetingExcel,
      clearDownloadAgendaMeetingExcelAction,
      getMeetingTypesDetails,
      downloadAgendaCabSecPpt,
      clearDownloadAgendaMeetingPptv2WithoutIssueAction,
      downloadAgendaMeetingPptv2PragatiFormat,
      clearDownloadAgendaMeetingPptv2PragatiFormatAction,
      getUpcommingAgendaFlagDispatch: getUpcommingAgendaFlagAction,
      clearDownloadUpdaloadAgendaTemplateAction,
      downloadUpdaloadAgendaTemplateAction
    },
    dispatch
  );
}

export default withRouter(
  PermissionHOC(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(AgendaDetails)
  )
);
